import { render } from "./FormModal.vue?vue&type=template&id=00001404&scoped=true"
import script from "./FormModal.js?vue&type=script&lang=js"
export * from "./FormModal.js?vue&type=script&lang=js"

import "./FormModal.vue?vue&type=style&index=0&id=00001404&lang=scss&scoped=true"

import exportComponent from "/home/ec2-user/src/FVC.frontend/Public/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00001404"]])

export default __exports__